module.exports = __webpack_public_path__ + "svg_80x80/blazor.51d7da.svg";